import { useEffect, useState } from "react";
import { Box, Typography, keyframes } from "@mui/material";
import { useThemeMode } from "../../../theme/ThemeModeProvider";
import { chatRailTokens } from "../tokens";

// Whimsical rotating verbs while a run is queued/running, à la Claude. Cycles
// every ~1.8s so the user sees motion without distraction. Keep the list
// short so the same verb doesn't appear twice during a typical turn.
const VERBS = [
  "Thinking",
  "Pondering",
  "Cogitating",
  "Reasoning",
  "Deliberating",
  "Reflecting",
  "Mulling",
  "Considering",
  "Noodling",
];

const blink = keyframes`
  0%, 80%, 100% { opacity: 0.3; }
  40% { opacity: 1; }
`;

export function ThinkingIndicator() {
  const { mode } = useThemeMode();
  const T = chatRailTokens(mode);
  const [verbIdx, setVerbIdx] = useState(() => Math.floor(Math.random() * VERBS.length));

  useEffect(() => {
    const id = setInterval(() => {
      setVerbIdx((i) => (i + 1) % VERBS.length);
    }, 1800);
    return () => clearInterval(id);
  }, []);

  return (
    <Box
      role="status"
      aria-live="polite"
      data-testid="thinking-indicator"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.5,
        py: 1,
        bgcolor: T.panel,
        border: `1px solid ${T.hair}`,
        borderRadius: `${T.r_md}px`,
        maxWidth: "85%",
        fontFamily: T.sans,
      }}
    >
      <Typography
        sx={{
          fontSize: T.fs_body,
          color: T.textDim,
          fontStyle: "italic",
        }}
      >
        {VERBS[verbIdx]}
      </Typography>
      <Box sx={{ display: "flex", gap: 0.4 }}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 4,
              height: 4,
              borderRadius: "50%",
              bgcolor: T.textMute,
              animation: `${blink} 1.4s ease-in-out infinite`,
              animationDelay: `${i * 0.16}s`,
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
